import { render, staticRenderFns } from "./BatchCreateCache.vue?vue&type=template&id=fdd2f7f2"
import script from "./BatchCreateCache.vue?vue&type=script&lang=js"
export * from "./BatchCreateCache.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports